import { gql } from "apollo-boost";

import useMutation, { mutationTypes } from "@utils/graphqlUtils";

const MUTATION = gql`
  mutation(
    $id: String!
    $data: FertilizationPlanUpdateInput!
  ) {
    updateOneFertilizationPlan(
      where: { id: $id }
      data: $data
    ) {
      id
    }
  }
`;

export default () => (
  useMutation(MUTATION, `Plano de fertilização actualizado`, mutationTypes.UPDATE)
);

